import React from "react";

function NetworksPage() {
  return <h1>Computer Networks Notes</h1>;
}

export default NetworksPage;